import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo-container">
          <Link to="/" className="logo">
            Gold Price Tracker
          </Link>
        </div>

        <button 
          className="mobile-menu-button"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="menu-icon"></span>
        </button>

        <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul className="nav-links">
            <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
            <li><Link to="/gold-calculator" onClick={() => setIsMenuOpen(false)}>Gold Calculator</Link></li>
            <li><Link to="/gold-prices" onClick={() => setIsMenuOpen(false)}>Gold Prices</Link></li>
            <li><Link to="/privacy-policy" onClick={() => setIsMenuOpen(false)}>Privacy Policy</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header; 